import D2C_Instance from '../Instance'

class D2C_InstanceCustom extends D2C_Instance {
  id = 'custom'
  static active = false
  static objectType = 'instanceType'
  static providerType = 'custom'
  get _title() {
    if (this.memory && this.cores) {
      return `${this.memory}GB RAM, ${this.cores} vCPU`
    }
    return ''
  }
  get _fullTitle() {
    if (this.storageType) {
      return `${this._title}, ${this.storageSize}GB ${this.storageType}`
    }
    return this._title
  }
}

export default D2C_InstanceCustom
